import * as React from "react";
import { Grid, Typography, Link } from "@mui/material";
import { AppBody } from "../AppBody";
import Breadcrumbs from "../../containers/Breadcrumbs";
import { appHeaderTitle } from "../../common/services/Utilities";
import APIDocStatic from "../../common/assets/images/API_icon_API_Static.svg";
import APIDocHover from "../../common/assets/images/API_icon_API_Focus.svg";
import API101Static from "../../common/assets/images/API_icon_API101_Static.svg";
import API101Hover from "../../common/assets/images/API_icon_API101_Focus.svg";
import BulkDataDownloadStatic from "../../common/assets/images/API_icon_Bulk_Static.svg";
import BulkDataDownloadHover from "../../common/assets/images/API_icon_Bulk_Focus.svg";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import { AppUrl } from "../../config";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";
import { useNavigate } from "react-router-dom";
import { LevelTwoAppCard, LevelTwoAppCardProps } from "../LevelTwoAppCard";

export default function BulkDataApi() {
  const navigate = useNavigate();

  useInitialPageLoad("bulkData");

  const introParagraph = (
    <>
      {appHeaderTitle("bulkData")}
      <Typography variant="body2" id="bulk-data-api-description">
        BankFind Suite enables users to search, filter, and download bank data
        using our Application Programming Interface (API), offering precise,
        customized control over the results.
      </Typography>
      <Typography variant="body2">
        Alternatively, some users prefer to request larger bulk datasets for
        more flexible offline processing. For this purpose, we provide a bulk
        data generator, also powered by our API, though it offers fewer
        customization options.
      </Typography>
      <Typography variant="body2" id="bulk-data-api-link">
        Provide{" "}
        <Link
          href={
            "https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=FinRegData"
          }
        >
          feedback or submit a question
        </Link>{" "}
        about this page.
      </Typography>
    </>
  );

  const bulkDataApps: LevelTwoAppCardProps[] = [
    {
      id: "bulkData",
      iconStatic: BulkDataDownloadStatic,
      iconHover: BulkDataDownloadHover,
      title: <>Bulk Data Download</>,
      alt: "Bulk Data Download",
      onClick: () =>
        navigate({
          pathname: `${AppUrl("BulkData")}/bulkDataDownload`,
        }),
    },
    {
      id: "apiDocs",
      iconStatic: APIDocStatic,
      iconHover: APIDocHover,
      title: <>API Documentation</>,
      alt: "API Documentation",
      onClick: () => (window.location.href = AppUrl("API")),
    },
    {
      id: "api101",
      iconStatic: API101Static,
      iconHover: API101Hover,
      title: <>API 101</>,
      alt: "API 101",
      onClick: () => navigate(`${AppUrl("BulkData")}/api101`),
    },
  ];

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs currentPageBreadCrumbTitle="Bulk Data and API" />
        </Grid>
      </Grid>
      <CloudFoundryBanner />
      <AppBody introText={introParagraph}>
        <Grid
          container
          spacing={2}
          sx={{ py: 3, maxWidth: 1200, mx: "auto", width: "100%" }}
        >
          {bulkDataApps.map((app) => (
            <Grid
              key={app.id}
              size={{
                xs: 12,
                md: 3,
              }}
              sx={{ height: 230 }}
            >
              <LevelTwoAppCard {...app} />
            </Grid>
          ))}
        </Grid>
      </AppBody>
    </>
  );
}
